import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import type { RootState } from "../store";
import LoadingSpinner from "../components/LoadingSpinner";
import { isAdminUser } from "../utils/constants";

interface RequireAdminAccessProps {
  children: React.ReactNode;
}

const RequireAdminAccess: React.FC<RequireAdminAccessProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  const allAgents = useSelector((state: RootState) => state.agents.data);
  const agentsLoading = useSelector((state: RootState) => state.agents.loading);

  useEffect(() => {
    if (!agentsLoading) {
      if (allAgents.length > 0) {
        const currentUserId = allAgents[0]?.user_id;
        const isAdmin = isAdminUser(currentUserId);

        if (isAdmin) {
          setIsAuthorized(true);
          setIsChecking(false);
        } else {
          navigate("/landing", { replace: true });
        }
      } else {
        // No agents data - fallback to localStorage check
        const storedUserId = parseInt(localStorage.getItem('user_id') || '0', 10);
        const isAdmin = isAdminUser(storedUserId);

        if (isAdmin) {
          setIsAuthorized(true);
          setIsChecking(false);
        } else {
          navigate("/landing", { replace: true });
        }
      }
    }
  }, [allAgents, agentsLoading, navigate]);

  // Show loading while checking
  if (agentsLoading || isChecking) {
    return <LoadingSpinner fullscreen label="Verifying access..." />;
  }

  // Only render children if authorized
  if (!isAuthorized) {
    return null;
  }

  return <>{children}</>;
};

export default RequireAdminAccess;
